import { render, staticRenderFns } from "./charts2.vue?vue&type=template&id=6b0e95dd&scoped=true&"
import script from "./charts2.vue?vue&type=script&lang=js&"
export * from "./charts2.vue?vue&type=script&lang=js&"
import style0 from "./charts2.vue?vue&type=style&index=0&id=6b0e95dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0e95dd",
  null
  
)

export default component.exports